// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalTopicsTable .GlobalTopicsTable-titleRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/modules/global-topic/global-topics-table/global-topics-table.styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAJ","sourcesContent":[".GlobalTopicsTable {\n  .GlobalTopicsTable-titleRow {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
